import type { FunctionComponent } from "react";
import { Fragment } from "react";

import { notEmpty } from "shared/lib/utils";

import { FilterOptions } from "./consts";
import { Container, FilterChip, FilterHeader, OuterContainer } from "./styles";

type AllVideosFilterProps = {
  className?: string;
  filterEntityUuid?: string;
  onFilterEntityUuidChange: (entityUuid: string) => void;
};

export const AllVideosFilter: FunctionComponent<AllVideosFilterProps> = ({
  className,
  filterEntityUuid,
  onFilterEntityUuidChange,
}) => (
  <OuterContainer className={className}>
    <Container>
      <FilterChip
        $isActive={filterEntityUuid === "" || filterEntityUuid === undefined}
        onClick={() => {
          if (!notEmpty(filterEntityUuid)) return;
          onFilterEntityUuidChange("");
        }}
      >
        All Videos
      </FilterChip>

      {FilterOptions.map((options, optionIndex) => (
        <Fragment key={optionIndex}>
          {options.header && <FilterHeader>{options.header}</FilterHeader>}

          {options.filters.map(filter => (
            <FilterChip
              $isActive={filterEntityUuid === filter.entityUuid}
              key={filter.entityUuid}
              onClick={() => onFilterEntityUuidChange(filter.entityUuid)}
            >
              {filter.name}
            </FilterChip>
          ))}
        </Fragment>
      ))}
    </Container>
  </OuterContainer>
);
